export const recordDelimiter = "124";
export const columnDelimiter = "59";
export const minDateBranchOutage = "2003-01-01";

export const displayCode = "4";
export const serviceDays = "-1";
